var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49226 1.5H13.4923V12.5H2.36976H1.49226V1.5ZM1.49226 0C0.667256 0 -0.000244141 0.675 -0.000244141 1.5L0.000107408 14H2.99226H13.4923C14.3173 14 14.9923 13.325 14.9923 12.5V1.5C14.9923 0.675 14.3173 0 13.4923 0H1.49226Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88306 11H3.99976L6.86936 3H9.1342L11.9998 11H10.1164L8.03426 4.82812H7.96931L5.88306 11ZM5.76536 7.85547H10.2139V9.17578H5.76536V7.85547Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language-icon.ecb95f8aa4d607ad9154755ed8ba083d.svg";
export { ForwardRef as ReactComponent };